import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import {
  englishIqDemoV2Schema,
  englishIqItemV2Schema,
  englishIqKindV2Schema,
  englishIqProgressV2Schema,
  englishIqSkillV2Schema,
} from '../schemasV2';

const startEnglishIqSessionV2DataSchema = z.object({
  assessmentVersion: z.number().int().positive(),
  demoPreload: englishIqDemoV2Schema.nullable(),
  expiresAt: z.number().int().positive(),
  item: englishIqItemV2Schema,
  kind: englishIqKindV2Schema,
  progress: englishIqProgressV2Schema,
  skill: englishIqSkillV2Schema.nullable(),
  token: z.string().min(1),
});

export type IStartEnglishIqSessionV2Data = z.infer<typeof startEnglishIqSessionV2DataSchema>;

export const startEnglishIqSessionV2ResponseSchema: z.ZodSchema<
  IAPI<IStartEnglishIqSessionV2Data>
> = createApiResponseSchema(startEnglishIqSessionV2DataSchema) as z.ZodSchema<
  IAPI<IStartEnglishIqSessionV2Data>
>;

export type IStartEnglishIqSessionV2Response = IAPI<IStartEnglishIqSessionV2Data>;
